module.exports = require("./Tabs");